<aside id="menuLateral" class="menu-lateral d-print-none" role="navigation" [class.omitir]="compartilhadoService.ocultarMenu">
  <div class="row m-0 mt-4 mb-4">
    <div class="col-12 text-center logo">
      <img src="../../../../assets/svg/logo-home.svg" alt="">
    </div>
  </div>

  <div class="row w-100 m-0 pt-3 nao-selecionavel" id="menu" [class.justify-content-end]="compartilhadoService.ocultarMenu">
    <ul class="pl-0">
      <li class="pl-3 link" (click)="compartilhadoService.ocultarMenu = !compartilhadoService.ocultarMenu">
        <img *ngIf="!compartilhadoService.ocultarMenu" src="../../../assets/icons/x-home.svg" />
        <img *ngIf="compartilhadoService.ocultarMenu" src="../../../assets/icons/menu.svg" style="margin-left: 155px;"/>
        <a *ngIf="!compartilhadoService.ocultarMenu" class="link">
          Fechar
        </a>
      </li>
      <li class="pl-3 link" style="margin-top: 12px;">
        <img src="../../../assets/icons/home.svg" [ngStyle]="{ 'margin-left': !compartilhadoService.ocultarMenu ? '0' : '155px'}" routerLink="/dashboard" (click)="compartilhadoService.ocultarMenu = !compartilhadoService.ocultarMenu"/>
        <a *ngIf="!compartilhadoService.ocultarMenu" class="link" routerLink="/dashboard" (click)="compartilhadoService.ocultarMenu = !compartilhadoService.ocultarMenu">
          Home
        </a>
      </li>
    </ul>
    <ng-container *ngFor="let menu of perfilMenu?.menus">

      <ul *ngIf="!compartilhadoService.ocultarMenu" class="pl-0">
        <li class="pl-3 link" (click)="subMenusAbertos[menu.id || menu.descricao] = !subMenusAbertos[menu.id || menu.descricao]" [class.active]="subMenusAbertos[menu.id || menu.descricao]">
          <img [src]="'../../../assets/icons/' + menu.icone" />
          <a class="link">
            {{ menu.descricao }}
          </a>
        </li>

        <div class="row m-0 p-0 collapse" [class.show]="subMenusAbertos[menu.id || menu.descricao]">
          <ul class="pl-3 submenu" *ngFor="let subMenu of menu.menus">
            <li (click)="compartilhadoService.ocultarMenu = !compartilhadoService.ocultarMenu">
              <a [routerLink]="[subMenu.link]">
                {{ subMenu.descricao }}
              </a>
            </li>
          </ul>
        </div>
      </ul>
      <ul *ngIf="compartilhadoService.ocultarMenu" class="pl-0">
        <li class="pl-3 link" style="margin-left: 155px;" (click)="compartilhadoService.ocultarMenu = !compartilhadoService.ocultarMenu">
          <img [src]="'../../../assets/icons/' + menu.icone" />
        </li>
      </ul>
    </ng-container>

  </div>
</aside>